import React from 'react';
import { Controller } from 'react-hook-form';
import useMeasureFilterFormContext from '../../utils/useMeasureFilterFormContext';
import { BetweenFields } from '../../../../../../Form';
import { StyledNumberInput } from './SingleMeasureFilterValuesUI';

interface IProps {
  filterIndex: number;
}

const SingleMeasureFilterBetweenValues = ({ filterIndex }: IProps) => {
  const { control } = useMeasureFilterFormContext();

  return (
    <BetweenFields>
      <Controller
        name={`filters.${filterIndex}.fromValue`}
        control={control}
        render={({ field, fieldState }) => (
          <StyledNumberInput
            {...field}
            ref={field.ref}
            placeholder="Value"
            value={field.value}
            error={fieldState.error?.message}
          />
        )}
      />
      <Controller
        name={`filters.${filterIndex}.toValue`}
        control={control}
        render={({ field, fieldState }) => (
          <StyledNumberInput
            {...field}
            ref={field.ref}
            placeholder="Value"
            value={field.value}
            error={fieldState.error?.message}
          />
        )}
      />
    </BetweenFields>
  );
};

export default SingleMeasureFilterBetweenValues;
